module.exports = __webpack_public_path__ + "static/media/b3_p15_narration.06ba7fda.mp3";